export enum StencilFuncName {
  AlwaysStencilFunc = 'AlwaysStencilFunc',
  EqualStencilFunc = 'EqualStencilFunc',
  GreaterEqualStencilFunc = 'GreaterEqualStencilFunc',
  GreaterStencilFunc = 'GreaterStencilFunc',
  LessEqualStencilFunc = 'LessEqualStencilFunc',
  LessStencilFunc = 'LessStencilFunc',
  NeverStencilFunc = 'NeverStencilFunc',
  NotEqualStencilFunc = 'NotEqualStencilFunc'
}
